import React from "react";
import { appTheme } from "../styles/appTheme";

type AppSectionCardProps = {
  children: React.ReactNode;
  style?: React.CSSProperties;
};

export default function AppSectionCard({
  children,
  style = {},
}: AppSectionCardProps) {
  return (
    <div
      style={{
        borderRadius: "12px",
        border: "none",
        background: appTheme.colors.cardBg,
        boxShadow: "none",
        padding: "18px",
        boxSizing: "border-box",
        ...style,
      }}
    >
      {children}
    </div>
  );
}
